<template>
     <div class="home" v-if="recentSubscribeList.length > 0">
          <swiper
          class="swiper"
          :options="swiperOption"
           @slideChange="onSlideChange"
           ref = "mySwiper"
      >
        <swiper-slide v-for="(chunk, index) in groupedList" :key="index">
            <div class="slide-content">
                <div class="system-dynamic-item" v-for="item in chunk" :key="item.id">
                    <span>用户：</span>
                    <span class="bold-font">{{ item.userName }}</span>
                    <span style="margin-left: 10px;">{{ subTypeActionNameEnum[item.subType] }}了{{ item.subTypeValueKeyTitle }}：</span>
                    <span class="bold-font">{{ item.subTypeValue }}</span>
                </div>
            </div>
        </swiper-slide>
      </swiper>
   </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import { getRecentSubscribe } from "@/api/common";
import { apiCallback } from "@/utils";
export default {
  name: 'RecentSubscribeSwiper',
  data(){
    return{
        swiperOption: {
          slidesPerView: 1,
          spaceBetween: 30,
          autoplay: {
            delay: 1000,
            // stopOnLastSlide: true
        },
          loop: true,
          direction: 'vertical',
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          }
        },
        subTypeEnum: {
            1: "提单订阅",
            2: "船期订阅",
            3: "集卡定位",
        },
        subTypeActionNameEnum: {
            1: "订阅",
            2: "订阅",
            3: "添加",
        },
        swipperCount: 0, // 记录下切换的次数，超过数据条数后重新获取数据
        recentSubscribeList: [],
        groupedList: [],
        timer: null, // 新增定时器引用
    }
  },
  components: {
      Swiper,
      SwiperSlide,
  },
  methods: {
    dealList(list) {
      return list.map(item => { 
        const { userName, blno, carNo, vesselsName, voyage } = item;
        let result = {
        }
        if (carNo) {
          result.subType = 3;
          result.subTypeValueKeyTitle = "车牌号";
          result.subTypeValue = carNo;
        } else if (blno) { 
          result.subType = 1;
          result.subTypeValueKeyTitle = "提单号";
          result.subTypeValue = blno;
        } else if (vesselsName) {
          result.subType = 2;
          result.subTypeValueKeyTitle = "船名/航次";
          result.subTypeValue = `${vesselsName}/${voyage}`;
        }
        return {
          ...result,
          userName: this.getPrivacyStr(userName),
          subTypeValue: this.getPrivacyStr(result.subTypeValue),
        }
      }).filter(record => record.userName);
    },
    getPrivacyStr(str) {
      if (!str || typeof str !== 'string') {
        return str;
      }
      
      const len = str.length;
      if (len <= 2) {
        // 如果字符串长度小于等于2，保留首字符，然后加两个星号
        return str.charAt(0) + '**';
      } else if (len <= 6) {
        // 如果字符串长度在3-6之间，保留首尾字符，中间用星号
        return str.charAt(0) + '*'.repeat(len - 2) + str.charAt(len - 1);
      } else {
        // 如果字符串长度大于4，保留前2个和后2个字符，中间用星号
        const starCount = Math.max(1, len - 4);
        return str.substring(0, 3) + '*'.repeat(starCount) + str.substring(len - 3);
      }
    },
    onSlideChange() {
      this.swipperCount+=3;
      const randowDelay = Math.floor(Math.random() * 60000);
      this.$refs.mySwiper?.$swiper.autoplay.stop();
      clearTimeout(this.timer);

      this.timer = setTimeout(() => {
        if (this.swipperCount >= this.recentSubscribeList.length - 5) {
          this.loadRecentSubscribe(true);
        }
        this.$refs.mySwiper?.$swiper.autoplay.start();
      }, randowDelay);
    },
    loadRecentSubscribe(needAppend){
      getRecentSubscribe().then(res => {
        const data = apiCallback(res);
        let newList = this.dealList(data);

        if (needAppend) {
          const cacheList = [...this.recentSubscribeList, ...newList];
          if (cacheList.length >= 150) { 
            cacheList.splice(0, 50)
            this.swipperCount -= 50;
          }
          this.recentSubscribeList = cacheList;
          this.groupedList = this.groupData(cacheList);
        } else {
          this.recentSubscribeList = newList;
          this.groupedList = this.groupData(newList);
        }
        // 不管哪种情况都重启autoplay
        this.$nextTick(() => { 
          this.$refs.mySwiper?.$swiper.autoplay.start();
        })
      }).catch(() => {
        // 拉取失败也要恢复autoplay
        this.$nextTick(() => { 
          this.$refs.mySwiper?.$swiper.autoplay.start();
        })
      });
    },
    groupData(list) {
      const groups = [];
      for (let i = 0; i < list.length; i += 3) {
        groups.push(list.slice(i, i + 3));
      }
      return groups;
    }
  },
  mounted() {
    this.loadRecentSubscribe();
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  }
}
</script>

<style lang="stylus">
.home
  width: 100%
  height: 30px
  background: rgba(255,255,255,0.6) // 半透明白，适配深浅色
  box-shadow: 0 2px 8px 0 rgba(0,0,0,0.04)
  display: flex
  align-items: center
  padding: 0 18px
  margin-bottom: 12px
  border: 1px solid rgba(120,90,200,0.08)
  color: #333333;

  .swiper
    height: 30px
    .swiper-slide
      display: flex
      align-items: center
      justify-content: center
      line-height: 30px
      font-size: 13px
      color: inherit // 跟随父级字体色
      background: transparent
      transition: background 0.2s
      cursor: pointer
      &:hover
        background: rgba(120, 90, 200, 0.10)
      .slide-content
        display: flex
        align-items: center
        justify-content: space-around
        width: 100%
      .bold-font
        font-weight: 600
        color: inherit
      .system-dynamic-item
        display: flex
        align-items: center
        white-space: nowrap
        overflow: hidden
        text-overflow: ellipsis
        flex-grow: 0
        padding: 0 8px
        .icon
          width: 18px
          height: 18px
          margin-right: 4px
</style>